import { Theme } from "@mui/material/styles";
import { z } from "zod";

export const leverValueColors = ["green", "orange", "red", "grey"] as const;

export type LeverValueColor = (typeof leverValueColors)[number];

export const LeverValueColorSchema = z.enum(leverValueColors);

const leverValueColorResolvers: Record<LeverValueColor, (theme: Theme) => string> = {
    green: (theme) => theme.custom.green[600],
    orange: (theme) => theme.custom.orange[600],
    red: (theme) => theme.custom.red[500],
    grey: (theme) => theme.custom.grey[1400],
};

export const getLeverValueColor = (theme: Theme, valueColor?: LeverValueColor | null): string | undefined => {
    return valueColor ? leverValueColorResolvers[valueColor](theme) : undefined;
};
